import { useEffect, useState } from "react";
import { Camera, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { getAllAwards, deleteAwardPhoto, awardPhotoUrl } from "@/lib/rewards";
import { errorText } from "@/lib/family";

export const TeacherNotes = ({ pin, profiles }) => {
  const [notes, setNotes] = useState([]);
  const load = () => getAllAwards().then((a) => setNotes(a.filter((x) => x.photo))).catch(() => setNotes([]));
  useEffect(() => { load(); }, []);
  const remove = async (id) => {
    if (!window.confirm("Permanently delete this teacher-note photo? This can't be undone.")) return;
    try { await deleteAwardPhoto(pin, id); toast.success("Photo permanently deleted"); load(); } catch (e) { toast.error(errorText(e)); }
  };
  if (!notes.length) return null;
  return (
    <section className="pp-card" data-testid="teacher-notes">
      <p className="pp-label">Parents only</p>
      <h2 className="pp-h2 flex items-center gap-2"><Camera className="h-5 w-5" /> Teacher-note photos</h2>
      <ul className="mt-4 grid gap-2">
        {notes.map((a) => (
          <li key={a.id} className="pp-award-row" data-testid={`teacher-note-${a.id}`}>
            <img className="pp-award-photo" src={awardPhotoUrl(a.id)} alt="Teacher note" loading="lazy" />
            <div className="flex-1 min-w-0"><b>{a.reason}</b>
              <p className="text-sm opacity-75">{profiles.find((p) => p.id === a.profile_id)?.name}</p></div>
            <button className="pp-ghost" onClick={() => remove(a.id)} data-testid={`teacher-note-delete-${a.id}`}>
              <Trash2 className="h-4 w-4" /> Delete photo
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
};
